document.addEventListener('DOMContentLoaded', function () {
    const subCollectionSwiper = new Swiper('#rocket-custom-sub-collections', {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freemode: true,
        mousewheel: {
            forceToAxis: true,
        },
        on: {
            init: function () {
                const activeSlide = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
                if (activeSlide !== -1) {
                    this.slideTo(activeSlide, 0, true);
                }
            },
        },
    });

    function updateDOM(doc) {
        const sectionHero = doc.querySelector('.collection-hero__inner');
        const sectionGrid = doc.getElementById('main_collection_grid');

        if (sectionHero) {
            const currentHero = document.querySelector('.collection-hero__inner');
            if (currentHero && currentHero.innerHTML !== sectionHero.innerHTML) {
                currentHero.innerHTML = sectionHero.innerHTML;
            }
        }

        if (sectionGrid) {
            const currentGrid = document.getElementById('main_collection_grid');
            if (currentGrid && currentGrid.innerHTML !== sectionGrid.innerHTML) {
                currentGrid.innerHTML = sectionGrid.innerHTML;
            }
        }
    }

    const contentCache = {};
    document.querySelectorAll('.sub-collections-item .sub-collections__item-content').forEach((item, index) => {
        item.addEventListener('click', async function (event) {
            event.preventDefault();
            if (this.classList.contains('loading')) return;
            document.querySelectorAll('.sub-collections-item').forEach(parentItems => {
                parentItems.classList.remove("is-active");
            });
            item.parentNode.classList.add("is-active");
            if (typeof subCollectionSwiper !== 'undefined') {
                subCollectionSwiper.slideTo(index, 300, true);
            }
            const container = item.closest("#MainContent");
            if (container) container.classList.add("fetching-content");

            const urlCollection = this.getAttribute('data-url');
            if (contentCache[urlCollection]) {
                updateDOM(contentCache[urlCollection]);
                if (container) container.classList.remove("fetching-content");
                if(document.getElementById('AjaxinatePagination')) {
                    new Ajaxinate({
                        container: '#product-grid',
                        pagination: '#AjaxinatePagination',
                        offset: 0,
                        callback: function() {
                        }
                    });
                }
                return;
            }

            try {
                this.classList.add('loading');
                const response = await fetch(urlCollection, { cache: "force-cache" });
                console.log(response);
                if (!response.ok) throw new Error('Fetch failed');
                const html = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                contentCache[urlCollection] = doc; // cache again

                updateDOM(doc);
                if (container) container.classList.remove("fetching-content");

                window.history.pushState({ path: urlCollection }, '', urlCollection);
            } catch (error) {
                console.error('Fetch error:', error);
            } finally {
                this.classList.remove('loading');
                if(document.getElementById('AjaxinatePagination')) {
                    new Ajaxinate({
                        container: '#product-grid',
                        pagination: '#AjaxinatePagination',
                        offset: 0,
                        callback: function() {
                        }
                    });
                }
            }
        });
    });
    window.addEventListener('popstate', function (event) {
        window.location.reload();
    });
});